import { render } from "./AddClient.vue?vue&type=template&id=f6673aac&scoped=true"
import script from "./AddClient.vue?vue&type=script&lang=js"
export * from "./AddClient.vue?vue&type=script&lang=js"

import "./AddClient.vue?vue&type=style&index=0&id=f6673aac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6673aac"]])

export default __exports__